import React from 'react';

const StatisticsPanel = ({ stats }) => {
  const getCategoryIcon = (category) => {
    const icons = {
      '學術': '📚',
      '體育': '🏃',
      '藝術': '🎨',
      '社會服務': '🤝',
      '領袖訓練': '👑',
      '考試': '📝',
      '假期': '🎊',
      '典禮': '🏛️',
      '競賽': '🏆'
    };
    return icons[category] || '📋';
  };

  // const getCategoryColor = (category) => {
  //   const colors = {
  //     '學術': 'blue',
  //     '體育': 'green',
  //     '藝術': 'purple',
  //     '社會服務': 'yellow',
  //     '領袖訓練': 'red',
  //     '考試': 'darkred',
  //     '假期': 'darkgreen',
  //     '典禮': 'darkblue',
  //     '競賽': 'orange'
  //   };
  //   return colors[category] || 'gray';
  // };

  const getGradeDistribution = () => {
    const distribution = stats.gradeDistribution || {};
    const total = Object.values(distribution).reduce((sum, count) => sum + count, 0);
    
    return Object.entries(distribution).map(([grade, count]) => ({
      grade: `中${grade}`,
      count,
      percentage: total > 0 ? Math.round((count / total) * 100) : 0
    }));
  };

  const getMonthlyActivityData = () => {
    const monthlyData = stats.monthlyActivityCount || {};
    const months = [
      '一月', '二月', '三月', '四月', '五月', '六月',
      '七月', '八月', '九月', '十月', '十一月', '十二月'
    ];
    
    return months.map((month, index) => {
      const monthKey = `${new Date().getFullYear()}-${(index + 1).toString().padStart(2, '0')}`;
      return {
        month,
        count: monthlyData[monthKey] || 0
      };
    });
  };

  const gradeDistribution = getGradeDistribution();
  const monthlyData = getMonthlyActivityData();
  const maxMonthlyCount = Math.max(...monthlyData.map(d => d.count), 1);

  return (
    <div className="statistics-panel">
      <div className="stats-header">
        <h3>📊 SLP 統計概覽</h3>
        <p>學生學習歷程系統整體數據</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">👥</div>
          <div className="stat-content">
            <h4>學生統計</h4>
            <div className="stat-number">{stats.totalStudents}</div>
            <p>總學生數</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">👨‍🏫</div>
          <div className="stat-content">
            <h4>教師統計</h4>
            <div className="stat-number">{stats.totalTeachers}</div>
            <p>總教師數</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">📋</div>
          <div className="stat-content">
            <h4>活動統計</h4>
            <div className="stat-number">{stats.totalActivities}</div>
            <p>總活動數</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">🎯</div>
          <div className="stat-content">
            <h4>參與統計</h4>
            <div className="stat-number">{stats.totalParticipations}</div>
            <p>總參與人次</p>
          </div>
        </div>
      </div>

      <div className="detailed-stats">
        <div className="category-distribution">
          <h4>活動類別分布</h4>
          <div className="category-stats">
            {Object.entries(stats.categoryStats || {}).map(([category, count]) => (
              <div key={category} className="category-stat-item">
                <div className="category-info">
                  <span className="category-icon">{getCategoryIcon(category)}</span>
                  <span className="category-name">{category}</span>
                </div>
                <div className="category-count">{count}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="grade-distribution">
          <h4>學生年級分布</h4>
          <div className="grade-stats">
            {gradeDistribution.map(({ grade, count, percentage }) => (
              <div key={grade} className="grade-stat-item">
                <div className="grade-info">
                  <span className="grade-name">{grade}</span>
                  <span className="grade-count">{count}人</span>
                </div>
                <div className="grade-bar">
                  <div 
                    className="grade-fill" 
                    style={{ width: `${percentage}%` }}
                  ></div>
                </div>
                <span className="grade-percentage">{percentage}%</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="monthly-activity-chart">
        <h4>月度活動趨勢</h4>
        <div className="chart-container">
          <div className="chart-bars">
            {monthlyData.map(({ month, count }, index) => (
              <div key={index} className="chart-bar">
                <div 
                  className="bar-fill"
                  style={{ 
                    height: `${(count / maxMonthlyCount) * 100}%`,
                    backgroundColor: count > 0 ? '#3b82f6' : '#e5e7eb'
                  }}
                ></div>
                <div className="bar-label">{month}</div>
                <div className="bar-value">{count}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="system-info">
        <div className="info-item">
          <span className="info-label">系統狀態:</span>
          <span className="info-value status-active">正常運行</span>
        </div>
        <div className="info-item">
          <span className="info-label">最後更新:</span>
          <span className="info-value">{new Date().toLocaleString('zh-TW')}</span>
        </div>
        <div className="info-item">
          <span className="info-label">數據來源:</span>
          <span className="info-value">Supabase + Mock Data</span>
        </div>
      </div>
    </div>
  );
};

export default StatisticsPanel;
